import type { BaseBlock } from "@/react/components/shared/BuilderUI/DataModel.types";

export const defaultData: BaseBlock = {
  id: "form-long-answer-block",
  type: "FormLongAnswerBlock",
  props: {
    label: {
      prop: "other",
      type: "string",
      value: "Long answer",
    },
    placeholder: {
      prop: "other",
      type: "string",
      value: "",
    },
    required: {
      prop: "other",
      type: "boolean",
      value: false,
    },
  },
};
